import { Topic } from 'common/client-data-types/topic'

export const getTopicSponsor = (topic: Topic) => {
    if (topic.id === 'business/public-companies' || topic.id === 'business/bulls-n-bears') {
        return 'bullsnbears'
    }
    return undefined
}
